import { Button, Container, Loader } from 'rsuite';
import { ActionFeedbackDialog } from '../../../components';
import styles from './ArquiteturaPrecos.module.scss';
import { ArquiteturaPrecosUploadModal } from './Components/ArquiteturaPrecosUploadModal';
import { usePriceArchitectureUpload } from './hooks/usePriceArchitectureUpload';

const ArquiteturaPrecos = () => {
  const {
    isUploadModalOpen,
    selectedFile,
    fileError,
    feedback,
    openUpload,
    closeUpload,
    handleFileChange,
    handleInvalidFile,
    handleDownloadTemplate,
    handleUpload,
    closeFeedback,
    retryUpload,
  } = usePriceArchitectureUpload();

  return (
    <>
      <Container className="main-container">
        <div className={styles.page}>
          <header className={styles.header}>
            <h1 className={styles.headerTitle}>Arquitetura de preços</h1>
            <p className={styles.headerDescription}>
              A Arquitetura de preços define relações estruturadas entre produtos, com o objetivo de garantir coerência comercial e automatizar regras de
              precificação.
            </p>
          </header>

          <div className={styles.cards}>
            <section className={styles.card}>
              <div className={styles.cardHeading}>
                <h2 className={styles.cardTitle}>Como funciona a arquitetura de preços?</h2>
                <div className={styles.cardCopy}>
                  <p>
                    A arquitetura de preços mantém a relação entre os preços de produtos de uma mesma marca ou de marcas diferentes. Escolha um produto como
                    referência e, na planilha, defina o fator de arquitetura de cada produto vinculado a ele.
                  </p>
                  <p>
                    A partir dessa configuração, calculamos a sugestão de preço do produto referência e aplicamos automaticamente o fator definido para refletir
                    essa sugestão nos demais produtos da arquitetura.
                  </p>
                  <p>
                    Ao entrar na arquitetura, um produto deixa de responder a outras regras de preço ativas, incluindo a lógica de Família/Produto Derivado do
                    ERP. A arquitetura tem prioridade sobre elas, então vale revisar se os produtos que você vai incluir já seguem alguma outra regra antes de
                    enviar o arquivo.
                  </p>
                </div>
              </div>
            </section>

            <section className={styles.card}>
              <div className={styles.cardHeading}>
                <h2 className={styles.cardTitle}>Envie seu arquivo com a arquitetura de preços atualizado</h2>
                <div className={styles.cardCopy}>
                  <p>
                    Envie um arquivo nos formatos .xlsx, .xls ou .csv com as colunas obrigatórias Id Arquitetura, Produto Referência, Produto e Fator de
                    Arquitetura.
                  </p>
                </div>
              </div>
              <div className={styles.cardCopy}>
                <p>
                  O arquivo enviado sempre substitui a arquitetura de preços vigente por completo. Inclua todos os produtos e relações que devem continuar
                  valendo.
                </p>
                <p>
                  <button type="button" className={styles.templateLink} onClick={handleDownloadTemplate}>
                    Baixe aqui
                  </button>{' '}
                  o modelo de arquivo.
                </p>
              </div>
              <Button className={styles.sendButton} appearance="primary" id="send-price-architecture-btn" onClick={openUpload}>
                ENVIAR ARQUIVO
              </Button>
            </section>
          </div>
        </div>
      </Container>

      <ArquiteturaPrecosUploadModal
        show={isUploadModalOpen}
        file={selectedFile}
        errorMessage={fileError}
        onFileChange={handleFileChange}
        onInvalidFile={handleInvalidFile}
        onDownloadTemplate={handleDownloadTemplate}
        onSubmit={handleUpload}
        onHide={closeUpload}
      />

      <ActionFeedbackDialog
        open={feedback?.type === 'processing'}
        type="other"
        icon={<Loader size="lg" />}
        title="Processando seu arquivo"
        description="Estamos validando o arquivo e atualizando a arquitetura de preços. Leva alguns instantes."
        dismissible={false}
      />

      <ActionFeedbackDialog
        open={feedback?.type === 'success'}
        type="success"
        title="Arquivo processado com sucesso"
        description="Sua arquitetura de preços foi atualizada. As novas relações passam a valer a partir da próxima integração de dados, que roda diariamente."
        onClose={closeFeedback}
        primaryAction={{ label: 'FECHAR', onClick: closeFeedback }}
      />

      <ActionFeedbackDialog
        open={feedback?.type === 'error'}
        type="warning"
        title="Não foi possível processar o arquivo"
        description={feedback?.type === 'error' ? feedback.message : ''}
        onClose={closeFeedback}
        primaryAction={{ label: 'TENTAR NOVAMENTE', onClick: retryUpload }}
      />
    </>
  );
};

export default ArquiteturaPrecos;
